import { useRef } from "react"

import LeftPalm from "@/assets/img/palmistry/scan/left_palm.webp"

import { scanCopy } from "../config/copy"
import { ScanNavbar } from "./scan-navbar"

interface PalmInstructionProps {
  onBack: () => void
  onTakePhoto: () => void
  onPhotoSelected: (dataUrl: string) => void
}

/** Left-palm instruction screen before opening the camera. */
export function PalmInstruction({ onBack, onTakePhoto, onPhotoSelected }: PalmInstructionProps) {
  const fileRef = useRef<HTMLInputElement>(null)

  const handleFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return
    const reader = new FileReader()
    reader.onload = () => {
      if (typeof reader.result === "string") onPhotoSelected(reader.result)
    }
    reader.readAsDataURL(file)
    event.target.value = ""
  }

  return (
    <div className="fixed inset-0 z-[1000] mx-auto flex w-full max-w-app flex-col bg-dark-base">
      <ScanNavbar onBack={onBack} />

      <div className="relative min-h-0 flex-1">
        <img src={LeftPalm} alt="" className="size-full object-cover" />
      </div>

      <div className="flex flex-col gap-4 px-4 pb-4">
        <h2 className="whitespace-pre-line text-center font-display text-2xl font-medium text-purple-light">
          {scanCopy.instruction.title}
        </h2>

        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={onTakePhoto}
            className="flex h-14 w-full items-center justify-center gap-2 rounded-full bg-gradient-to-b from-peach to-purple-accent font-body text-base font-semibold text-white"
          >
            {scanCopy.instruction.takePhoto}
          </button>

          <label className="flex h-14 w-full cursor-pointer items-center justify-center rounded-full bg-purple-light/10 font-body text-base font-semibold text-purple-light">
            {scanCopy.instruction.upload}
            <input
              ref={fileRef}
              type="file"
              accept="image/png, image/jpeg"
              onChange={handleFile}
              className="hidden"
            />
          </label>
        </div>
      </div>
    </div>
  )
}
